import React from 'react';
import { Badge, Button, Form, Navbar } from 'react-bootstrap';
import { ExclamationDiamondFill, InfoCircleFill } from 'react-bootstrap-icons';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getAxiosErrorResponse } from '../../api/utils';

import { AuthenticatedContextConsumer } from '../../context/AuthenticatedContext';

const Header: React.FunctionComponent = () => {
  const history = useHistory();
  const [isDisabled, setIsDisabled] = React.useState(false);
  const hrefPortal = history.createHref({ pathname: '/portal' });
  return (
    <AuthenticatedContextConsumer>
      {({ isAuthenticated, loginCustomer, logout }) => {
        const accessType = loginCustomer?.accessType;
        return (
          <Navbar
            className="bg-Unknown justify-content-between"
            variant="dark"
            bg={accessType}
          >
            <Navbar.Brand href={hrefPortal}>計測装置データ</Navbar.Brand>
            {isAuthenticated ? (
              <Form
                inline
                onSubmit={(event) => {
                  event.preventDefault();
                  setIsDisabled(true);
                  logout()
                    .then((res) => {
                      setIsDisabled(false);
                      history.push('/login');
                      toast.success(
                        () => (
                          <>
                            <InfoCircleFill />
                            <span>{' ログアウト成功'}</span>
                          </>
                        ),
                        {
                          autoClose: 3000,
                          // onClose: () => history.push('/login'),
                        },
                      );
                      return res;
                    })
                    .catch((error) => {
                      const res = getAxiosErrorResponse(error);
                      toast.error(() => {
                        return (
                          <>
                            <ExclamationDiamondFill />
                            <span>{` ログアウト失敗`}</span>
                            <small>{` (${res?.status ?? '応答なし'})`}</small>
                          </>
                        );
                      });
                      setIsDisabled(false);
                    });
                }}
              >
                <Badge className="mx-1" variant="light">
                  {loginCustomer?.customerName}
                </Badge>
                <Badge className="mx-1" variant="light" pill>
                  {loginCustomer?.customerOfficeName}
                </Badge>
                <Button className="mx-1" type="submit" disabled={isDisabled}>
                  ログアウト
                </Button>
              </Form>
            ) : (
              <></>
            )}
          </Navbar>
        );
      }}
    </AuthenticatedContextConsumer>
  );
};

export default Header;
